<script setup>
import { computed } from 'vue';
import { useLocoI18n } from 'custom/composables/useLocoI18n';
import { UNOFFICIAL_PROVIDERS } from './providers';
import WhatsappConnectionPanel from './WhatsappConnectionPanel.vue';
import WhatsappOptions from './WhatsappOptions.vue';
import WhatsappSwitchProvider from './WhatsappSwitchProvider.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useLocoI18n();

const isUnofficial = computed(() =>
  UNOFFICIAL_PROVIDERS.includes(props.inbox.provider)
);
</script>

<template>
  <div class="flex flex-col gap-10 py-6">
    <section v-if="isUnofficial" class="flex flex-col gap-4">
      <h2 class="text-heading-2 text-n-slate-12">
        {{ t('LOCO.WHATSAPP.CONNECTION.TITLE') }}
      </h2>
      <WhatsappConnectionPanel :key="inbox.provider" :inbox-id="inbox.id" />
    </section>

    <WhatsappOptions
      v-if="isUnofficial"
      :key="`options-${inbox.provider}`"
      :inbox="inbox"
    />

    <WhatsappSwitchProvider :inbox="inbox" />
  </div>
</template>
